/* eslint-disable */
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Paper } from '@mui/material';
import { AuthContext } from '../../contexts/authContext';
import { forgotHeaderStyle, inputStyle, paperStyle } from '../styles';
import { InputAdornment, TextField } from '@mui/material';
import { PasswordType } from '../../interfaces/IPassType';
import { AuthPAGES } from '../../constants/pages';
import { Header } from '../../components/Header/Header';
import { MuiButton } from '../../components/Button/Button';
import LocalHospitalRoundedIcon from '@mui/icons-material/LocalHospitalRounded';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  useGetRoleListQuery,
  useGetSpecialtyListQuery,
} from '../../../../apis/CommonApi';
import { useValidPractice } from '../../hooks/useValidPractice';

const AdditionalInfo: React.FunctionComponent = () => {
  /* States and context declaration */
  const { practice, setPractice, invalidPracticeMessage } =
    useValidPractice(null);
  const [specialty, setSpecialty] = React.useState('');
  const [role, setRole] = React.useState('');
  const { data: roles } = useGetRoleListQuery();
  const { data: specialties } = useGetSpecialtyListQuery();

  const authContext = useContext(AuthContext);

  const navigate = useNavigate();

  /* Generic Error Message */
  // const [genericErrorMessage, setGenericErrorMessage] = useState("");

  const onNextClicked = async (e: any) => {
    e.stopPropagation();
    if (role && specialty && practice) {
      authContext.setRole(role);
      authContext.setSpecialty(specialty);
      authContext.setPractice(practice);
      navigate(`${AuthPAGES.checkPassword}/${PasswordType.SIGNUP}`);
    }
  };

  const changeSpecialty = (event: SelectChangeEvent) => {
    setSpecialty(event.target.value as string);
  };

  const changeRole = (event: SelectChangeEvent) => {
    setRole(event.target.value as string);
  };

  const isButtonDisabled = () => {
    return !role || !specialty || !practice || invalidPracticeMessage !== '';
  };

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={4} lg={4} md={5} sm={6} xs={12}>
        <Paper elevation={1} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <Header text1='Professional Info' text2='' />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <InputLabel id='demo-simple-select-label'>Practice Name</InputLabel>
            <TextField
              id='outlined-adornment-email'
              size='small'
              type='text'
              fullWidth
              value={practice}
              error={invalidPracticeMessage !== ''}
              helperText={invalidPracticeMessage ?? ''}
              onChange={(e: any) => setPractice(e.target.value)}
              InputProps={{
                style: { borderRadius: '50px' },
                startAdornment: (
                  <InputAdornment position='start'>
                    <LocalHospitalRoundedIcon
                      style={{ color: '#227BEF', width: '20px' }}
                    />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <InputLabel
              id='demo-simple-select-label'
              style={{ marginTop: '12px' }}
            >
              Role
            </InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              fullWidth
              value={role}
              style={{
                ...inputStyle,
                marginTop: '0px',
              }}
              onChange={changeRole}
            >
              {roles?.map((r) => (
                <MenuItem key={r} value={r}>
                  {r}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <InputLabel
              id='demo-simple-select-label'
              style={{ marginTop: '12px' }}
            >
              Specialty
            </InputLabel>
            <Select
              labelId='demo-simple-select-label'
              id='demo-simple-select'
              fullWidth
              value={specialty}
              style={{
                ...inputStyle,
                marginTop: '0px',
              }}
              onChange={changeSpecialty}
            >
              {specialties?.map((s) => (
                <MenuItem key={s} value={s}>
                  {s}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={{ marginTop: '32px' }}>
            <MuiButton
              loading={false}
              disabled={isButtonDisabled()}
              text='Continue'
              onSubmit={onNextClicked}
            />
          </Grid>
          {/* <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            <Typography style={pLabelDarkerStyle}>
              Have an account?
              <br />
              <Link
                to={AuthPAGES.signIn}
                style={{ ...pLabelStyle, marginLeft: "5px" }}>
                Sign in
              </Link>
            </Typography>
          </Grid> */}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AdditionalInfo;
